/**
 * Asynchronously loads the component for DormantCampaignsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DormantCampaignsPage = lazyLoad(
  () => import('./index'),
  module => module.DormantCampaignsPage,
);
